<template>
  <div>
    <CrudList
      title="Coins"
      storeName="Coins"
      labelAddNew="Agregar"
      :canAdd="false"
      :canEdit="true"
      :canDelete="false"
      sortable
      next-link="/admin/liquidations"
      :breadcrumbs="[
        {
          text: 'Finanzas',
          disabled: false,
          href: '/admin/coins'
        },
        {
          text: 'Coins',
          disabled: false,
          href: '#'
        }
        
      ]"
    >
    </CrudList>
  </div>
</template>

<script>
  import CrudList from "@/components/Crud/CrudList";

  export default {
    components: {CrudList},
    data: () => ({
      offsetTop: 0,
    }),
    methods: {
      onScroll (e) {
        this.offsetTop = e.target.scrollTop
      },

    },
  };
</script>
